import { render } from "./ScreenDonutChart.vue?vue&type=template&id=85020946&scoped=true"
import script from "./ScreenDonutChart.vue?vue&type=script&lang=js"
export * from "./ScreenDonutChart.vue?vue&type=script&lang=js"

import "./ScreenDonutChart.vue?vue&type=style&index=0&id=85020946&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85020946"]])

export default __exports__